var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgVerified = _a => {
  var _b, _c, _d;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_4244_757)"
  }, React.createElement("path", {
    id: "Icon color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11C22 17.0752 17.0752 22 11 22C4.92486 22 0 17.0752 0 11C0 4.92486 4.92486 0 11 0C17.0752 0 22 4.92486 22 11ZM16.7773 7.99266C17.1046 7.61859 17.0667 7.05001 16.6926 6.72269C16.3186 6.39538 15.75 6.43329 15.4227 6.80736L9.75428 13.2855L6.5345 10.0848C6.18199 9.73438 5.61214 9.73607 5.26172 10.0886C4.91129 10.4411 4.91298 11.0109 5.26549 11.3614L9.16549 15.2383C9.34182 15.4136 9.5828 15.5081 9.83128 15.4995C10.0798 15.4908 10.3136 15.3798 10.4773 15.1927L16.7773 7.99266Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4244_757"
  }, React.createElement("rect", {
    width: 22,
    height: 22,
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }))));
};
export default SvgVerified;